/** Availability defaults on; a saved boolean remains the learner's choice. */
export const DEFAULT_TUTOR_WHITEBOARD_ENABLED = true;

export function resolveTutorWhiteboardEnabled(value: unknown): boolean {
  return typeof value === "boolean" ? value : DEFAULT_TUTOR_WHITEBOARD_ENABLED;
}
